import { Typography, Link } from "@mui/material";

const Copyright: React.FC = () => {
  return (
    <Typography
      textAlign="center"
      variant="body2"
    >
      Copyright ©{" "}
      <Link
        color="textDisabled"
        href="https://www.siamkubota.co.th/"
        target="_blank"
        rel="noopener"
      >
        Siam Kubota Web Application
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default Copyright;
